import {create} from "zustand"

import {ChatbotEvent} from "@proto/chatbot/v1alpha/chatbot"
import {EventTypeArticleHitsIteration, EventTypeArticleHitsReport} from "@/lib/chat/messages"

interface UseWebsocketStoreProps {
    websocket: WebSocket | null
    setWebsocket: (ws: WebSocket | null) => void
    isConnected: boolean
    setIsConnected: (isConnected: boolean) => void
    messages: ChatbotEvent[]
    setMessages: (messages: ChatbotEvent[]) => void
    addMessage: (message: ChatbotEvent) => void
    reconnectTimer: NodeJS.Timeout | null
    setReconnectTimer: (reconnectTimer: NodeJS.Timeout | null) => void
    responseTimer: NodeJS.Timeout | null
    setResponseTimer: (responseTimer: NodeJS.Timeout | null) => void
    responseHasTimedOut: boolean
    setResponseHasTimedOut: (responseHasTimedOut: boolean) => void
}

const useWebsocketStore = create<UseWebsocketStoreProps>((set) => ({
    websocket: null,
    setWebsocket: (ws: WebSocket | null) => set({websocket: ws}),
    isConnected: false,
    setIsConnected: (isConnected: boolean) => set({isConnected}),
    messages: [],
    setMessages: (messages: ChatbotEvent[]) => set({messages}),
    addMessage: (message: ChatbotEvent) => set((state) => handleNewMessage(state, message)),
    reconnectTimer: null,
    setReconnectTimer: (reconnectTimer: NodeJS.Timeout | null) => set({reconnectTimer}),
    responseTimer: null,
    setResponseTimer: (responseTimer: NodeJS.Timeout | null) => set({responseTimer}),
    responseHasTimedOut: false,
    setResponseHasTimedOut: (responseHasTimedOut: boolean) => set({responseHasTimedOut}),
}))

const handleNewMessage = (state: {messages: ChatbotEvent[]}, message: ChatbotEvent) => {
    // Handle ArticleHitsReport messages
    if (message.type === EventTypeArticleHitsReport) {
        try {
            // Parse the new report
            const newReport = JSON.parse(message.message)

            // Find existing report in messages
            const existingIndex = state.messages.findIndex((msg) => {
                if (msg.type === EventTypeArticleHitsReport) {
                    try {
                        const existingReport = JSON.parse(msg.message)
                        return existingReport.report_id === newReport.report_id
                    } catch {
                        return false
                    }
                }
                return false
            })

            if (existingIndex !== -1) {
                // Replace existing report with new one
                const newMessages = [...state.messages]
                newMessages[existingIndex] = message
                return {messages: newMessages}
            }

            // If no existing report found, append the new one
            return {messages: [...state.messages, message]}
        } catch (error) {
            console.error("Error processing article hits report:", error)
            return state
        }
    }

    // Default behavior: append message to the end
    return {messages: [...state.messages, message]}
}

export default useWebsocketStore
